import React from "react";
import { View } from "@/styles/reactnative";
import { Sliders, Tab, Tabs } from "./TabUtils";

// const tabs = [
//     { tabName: 'Dashboard', TabComponent: Pane1 },
//     { tabName: 'Master Trader', TabComponent: Pane2 },
//     { tabName: 'Orders', TabComponent: Pane3 },
// ];
// Not using for Now! animation tab slider
const CustomTabs = ({ tabs }) => {
  const [focusedIdx, setFocusedIdx] = React.useState(0);
  return (
    <View style={{ alignItems: "flex-start", width: "100%", height: "100%" }}>
      <Tabs focusedIdx={focusedIdx} onChange={setFocusedIdx}>
        {tabs.map((item: any, index: any) => (
          <Tab title={item.tabName} key={index.toString()} />
        ))}
      </Tabs>
      <Sliders focusedIdx={focusedIdx}>
        {tabs.map(({ TabComponent }: any, index: any) => (
          <TabComponent key={index.toString()} />
        ))}
      </Sliders>
    </View>
  );
};

export default React.memo(CustomTabs);
